import SlideGameCard from '@/components/Slide/Game/Board/Card';
import { GameReportBoardRound } from '../props';
import styles from './styles.module.scss';

export default function SlideGameReportBoard({ round }: GameReportBoardRound) {
  return (
    <div className={styles.container}>
      <SlideGameCard
        prizeIndex={round?.crash?.crashpoint?.toNumber()}
        tile={round?.roulette?.tile}
        hasStopedSlide={true}
      />
    </div>
  );
}
